import * as L from 'leaflet';

window.addEventListener("load", function (event) {
    const maps = document.querySelectorAll('[data-behaviour="map"]');

    if(document.querySelector('[data-behaviour="logout"]')) {
        setInterval(function() {
            fetch("Security/ping").then(() => {
                console.log ('Ping')
            });
        }, 180*1000);
    }
    const toggle = document.querySelector('[data-behaviour="menu-toggle"]')
    if(toggle) {
        toggle.addEventListener("click", () => {
            document.body.classList.toggle('body--shownav');
            toggle.classList.toggle('is-active');
        })
    }

    const menuArrows = document.querySelectorAll('[data-behaviour="toggle-submenu"]')
    menuArrows.forEach((arrow) => {
        arrow.addEventListener("click", () => {
            arrow.parentNode.classList.toggle('menu--show-submenu');
        })
    });

    L.Icon.Default.imagePath = 'leaflet/';

    [...maps].forEach((node) => {
        let zoom = 5;
        if(window.innerWidth < 400) {
            zoom = 3;
        }

        const map = L.map(node.id).setView([54.062, -4.012], zoom);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: 'Kartendaten &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> Mitwirkende',
            useCache: true
        }).addTo(map);

        const lat = node.getAttribute("data-lat");
        const long = node.getAttribute("data-long");

        var marker = L.marker([lat, long], {

        }).addTo(map);

        node.classList.remove('leaflet-safari');

        console.log(map.getZoom());
    })

    // Glossary
    const showHides = document.querySelectorAll('[data-behaviour="show-hide"]');

    const entries = [...showHides].map(node => {
        node.addEventListener('click', (e) => {
            node.parentNode.classList.toggle('entry--show');
        });
    });

});
